module.exports = __webpack_public_path__ + "img/clock-time-icon.62b8975a.svg";